import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const otherwise: SugarElementInfo = {
    name: "otherwise",
    availableChildren: { type: AvailableChildrenType.Any },
};
